import React, { useState, useEffect } from 'react';
import { initializeWebStorage } from './src-utils-miaw-web-storage-utils.js';
import { storeOrganizationId, storeDeploymentDeveloperName, storeSalesforceMessagingUrl } from './src-utils-miaw-chat-config.js';

const MiawChatContext = React.createContext({
  state: { conversationMessages: [], sfConfig: { orgId: "", developerName: "", scrtURL: "" } },
  setState: () => {
  }
});
const MiawChatProvider = ({ children, queueInfo, sfConfig, enableTypingIndicator }) => {
  const [state, setState] = useState({ conversationMessages: [], queueInfo, sfConfig, enableTypingIndicator });
  useEffect(() => {
    if (sfConfig?.orgId) {
      initializeWebStorage(sfConfig.orgId);
      storeOrganizationId(sfConfig?.orgId);
      storeDeploymentDeveloperName(sfConfig?.developerName);
      storeSalesforceMessagingUrl(sfConfig?.scrtURL);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(
    MiawChatContext.Provider,
    {
      value: {
        state,
        setState
      }
    },
    children
  );
};

export { MiawChatContext, MiawChatProvider };
//# sourceMappingURL=src-contexts-MiawChatContext.js.map
